import { z } from "zod";
import { colorDataSchema } from "./data";
import {
  ControlDataTypeKey,
  Types,
  Schema
} from "./prop-controllers";
import { match } from "ts-pattern";
const responsiveColorDataSchema = Schema.responsiveValue(colorDataSchema);
const responsiveColorPropControllerDataV0Schema = responsiveColorDataSchema;
const ResponsiveColorPropControllerDataV1Type = "prop-controllers::responsive-color::v1";
const responsiveColorPropControllerDataV1Schema = z.object({
  [ControlDataTypeKey]: z.literal(ResponsiveColorPropControllerDataV1Type),
  value: responsiveColorDataSchema
});
const responsiveColorPropControllerDataSchema = z.union([
  responsiveColorPropControllerDataV0Schema,
  responsiveColorPropControllerDataV1Schema
]);
function ResponsiveColor(options = {}) {
  return { type: Types.ResponsiveColor, version: 1, options };
}
function getResponsiveColorPropControllerDataResponsiveColorData(data) {
  return match(data).with(
    { [ControlDataTypeKey]: ResponsiveColorPropControllerDataV1Type },
    (v1) => v1.value
  ).otherwise((v0) => v0);
}
function createResponsiveColorPropControllerDataFromResponsiveColorData(definition, responsiveColorData) {
  return match(definition).with(
    { version: 1 },
    () => ({
      [ControlDataTypeKey]: ResponsiveColorPropControllerDataV1Type,
      value: responsiveColorData
    })
  ).otherwise(() => responsiveColorData);
}
function getResponsiveColorDataSwatchIds(data) {
  return data.map((override) => override.value.swatchId);
}
function getResponsiveColorPropControllerDataSwatchIds(data) {
  if (data == null)
    return [];
  return getResponsiveColorDataSwatchIds(
    getResponsiveColorPropControllerDataResponsiveColorData(data)
  );
}
function copyResponsiveColorData(data, context) {
  return data.map((override) => ({
    ...override,
    value: copyColorValue(override.value)
  }));
  function copyColorValue(colorValue) {
    return {
      ...colorValue,
      swatchId: context.replacementContext.swatchIds.get(colorValue.swatchId) ?? colorValue.swatchId
    };
  }
}
function copyResponsiveColorPropControllerData(data, context) {
  return match(data).with(void 0, () => void 0).with(
    { [ControlDataTypeKey]: ResponsiveColorPropControllerDataV1Type },
    (v1) => ({
      [ControlDataTypeKey]: ResponsiveColorPropControllerDataV1Type,
      value: copyResponsiveColorData(v1.value, context)
    })
  ).otherwise((v0) => copyResponsiveColorData(v0, context));
}
export {
  ResponsiveColor,
  copyResponsiveColorData,
  copyResponsiveColorPropControllerData,
  createResponsiveColorPropControllerDataFromResponsiveColorData,
  getResponsiveColorDataSwatchIds,
  getResponsiveColorPropControllerDataResponsiveColorData,
  getResponsiveColorPropControllerDataSwatchIds,
  responsiveColorPropControllerDataSchema
};
//# sourceMappingURL=responsive-color.js.map